import { Menu, MenuItem, Position } from "@blueprintjs/core"
import CustomButton from "components/Atoms/CustomButton"
import CustomPopover from "components/Atoms/CustomPopover"
import ROUTES from "constants/routes.constants"
import React from "react"
import { useNavigate } from "react-router-dom"

const DcActions = ({ distributionCenter }) => {
  const navigate = useNavigate()
  return (
    <>
      <CustomPopover
        position={Position.BOTTOM_LEFT}
        minimal={true}
        content={
          <Menu>
            <MenuItem
              text="Distribution Center"
              icon="edit"
              onClick={e => navigate(ROUTES.dcDetail(distributionCenter?.id))}
            />
            {/* <MenuItem text="Delete" icon="trash" /> */}
          </Menu>
        }
      >
        <CustomButton
          style={{ transform: "rotate(90deg)" }}
          icon="more"
          minimal={true}
        />
      </CustomPopover>
    </>
  )
}

export default DcActions
